"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("./styles");

var _styles2 = require("@material-ui/core/styles");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Topbar = function Topbar(_ref) {
  var sidebarOpen = _ref.sidebarOpen,
      classes = _ref.classes,
      children = _ref.children;
  return _react["default"].createElement("header", {
    className: classes.topbar
  }, _react["default"].createElement("div", {
    className: "".concat(classes.content, " + ").concat(sidebarOpen ? classes.sidebarOpen : classes.sidebarClosed)
  }, children));
};

var _default = (0, _styles2.withStyles)(_styles.styles)(Topbar);

exports["default"] = _default;